import { TableCell } from '@e2n/ui';
import { getWeekdayByDate } from '@/utils';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function ZeitpunktCell({
  datum,
  type,
}: {
  datum: string;
  type: 'current' | 'prevWeek' | 'prevMonth' | 'prevYear';
}) {
  const { t } = useTranslation();

  return (
    <TableCell className="font-medium py-4 ps-0">
      <div className="text-xs text-neutrals-700">
        {t(
          `domain.controlling.umsatzplanung.planung.historieZeitpunkt.${type}`,
        )}
      </div>
      <div className="text-neutrals-900 text-sm font-semibold">
        {getWeekdayByDate(dayjs(datum).toDate()).shortage +
          '., ' +
          dayjs(datum).format('DD.MM.YYYY')}
      </div>
    </TableCell>
  );
}
